import PropTypes from 'prop-types'

export const brandShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  logo: PropTypes.string
})

export const modelShape = PropTypes.shape({
  name: PropTypes.string,
  url: PropTypes.string,
  price: PropTypes.number,
  funding: PropTypes.number
})

export const finishesShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ),
  equipements: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  )
})

export const motorShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  energy: PropTypes.string.isRequired,
  gearBox: PropTypes.string.isRequired,
  power: PropTypes.number.isRequired,
  consumption: PropTypes.number.isRequired,
  co2: PropTypes.number.isRequired
})

const designExteriorTypeShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  type: PropTypes.number,
  price: PropTypes.number.isRequired
})

const designExteriorColorShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  id: PropTypes.string
})

const designExteriorShape = PropTypes.shape({
  type: designExteriorTypeShape,
  color: designExteriorColorShape
})

const designInteriorShape = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.number,
    price: PropTypes.number.isRequired
  })
)

const designInteriorLeatherShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  serial: PropTypes.bool.isRequired
})

const designInteriorFabricShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  serial: PropTypes.bool.isRequired
})

export const designShape = PropTypes.shape({
  exterior: designExteriorShape,
  interior: designInteriorShape
})

export const designListShape = PropTypes.shape({
  exterior: PropTypes.shape({
    type: PropTypes.arrayOf(designExteriorTypeShape),
    color: PropTypes.arrayOf(designExteriorColorShape)
  }),
  interior: PropTypes.shape({
    leathers: PropTypes.arrayOf(designInteriorLeatherShape),
    fabrics: PropTypes.arrayOf(designInteriorFabricShape)
  })
})

export const optionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired
})

const subGroupOptionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(optionShape)
})
export const groupOptionsShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(subGroupOptionShape)
})

const serviceContractShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired
})

export const fundingShape = PropTypes.shape({
  label: PropTypes.string,
  description: PropTypes.string,
  bring: PropTypes.number,
  maxStep: PropTypes.number,
  minStep: PropTypes.number,
  step: PropTypes.number,
  monthly: PropTypes.number,
  price: PropTypes.number
})

export const configuratorShape = PropTypes.shape({
  price: PropTypes.number,
  brandsList: PropTypes.arrayOf(brandShape),
  brand: brandShape,
  modelsGroupList: PropTypes.arrayOf(modelShape),
  modelGroup: PropTypes.shape(),
  modelsList: PropTypes.arrayOf(modelShape),
  modelSelectedList: PropTypes.arrayOf(modelShape),
  model: modelShape,
  finishesList: PropTypes.arrayOf(finishesShape),
  finishes: finishesShape,
  motorsList: PropTypes.arrayOf(motorShape),
  motor: motorShape,
  designList: designListShape,
  design: designShape,
  optionsList: PropTypes.shape(),
  options: PropTypes.arrayOf(optionShape),
  serviceContractsList: PropTypes.arrayOf(serviceContractShape),
  serviceContracts: PropTypes.arrayOf(serviceContractShape),
  fundingList: PropTypes.arrayOf(fundingShape),
  funding: fundingShape
})
